<template>
  <el-main class="main-con el-main">
        <nav-breadcrumb :menu="[{label: '帮助文档'}]"/>
        <ul class="note-mesg-list bg-purple">
          <li>
            <i></i>
            <a target="_blank" href="static/docs/jxkdqdsczsc.pptx" download="金鑫科贷渠道商操作手册.pptx">金鑫科贷渠道商操作手册</a>
            <span>2020-05-15</span>
          </li>
          <li>
            <i></i>
            <a target="_blank" href="static/docs/jxkdsxdhtglczsc.pptx" download="金鑫科贷随鑫贷后台管理操作手册.pptx">金鑫科贷随鑫贷后台管理操作手册</a>
            <span>2020-05-15</span>
          </li>
          <li>
            <i></i>
            <a target="_blank" href="static/docs/jxkdkhczsc.pptx" download="金鑫科贷客户操作手册.pptx">金鑫科贷客户操作手册</a>
            <span>2020-05-15</span>
          </li>
        </ul>

  </el-main>
</template>

<script>
  export default {
    name: "MessageList",
    data() {
      return {
        messageType: 'trade'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Message/HelpFile.vue